import api from './api';

export const authService = {
  async register(userData) {
    const response = await api.post('/auth/register', userData);
    if (response.data.access_token) {
      localStorage.setItem('userToken', response.data.access_token);
      localStorage.setItem('userName', response.data.user?.nombre || userData.nombre);
      localStorage.setItem('userApproved', response.data.user?.is_approved || false);
      localStorage.setItem('userAdmin', response.data.user?.is_admin || false);
    }
    return response.data;
  },

  async login(credentials) {
    const response = await api.post('/auth/login', credentials);
    if (response.data.access_token) {
      localStorage.setItem('userToken', response.data.access_token);
      localStorage.setItem('userName', response.data.user?.nombre || '');
      localStorage.setItem('userApproved', response.data.user?.is_approved || false);
      localStorage.setItem('userAdmin', response.data.user?.is_admin || false);
    }
    return response.data;
  },

  async getCurrentUser() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  logout() {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userName');
    localStorage.removeItem('userApproved');
    localStorage.removeItem('userAdmin');
  },

  isAuthenticated() {
    return !!localStorage.getItem('userToken');
  },

  isApproved() {
    return localStorage.getItem('userApproved') === 'true';
  },

  isAdmin() {
    return localStorage.getItem('userAdmin') === 'true';
  }
};

export const estudiosService = {
  async getAll(params = {}) {
    const response = await api.get('/estudios', { params });
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/estudios/${id}`);
    return response.data;
  }
};

export const sucursalesService = {
  async getAll() {
    const response = await api.get('/sucursales');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/sucursales/${id}`);
    return response.data;
  }
};

export const citasService = {
  async create(citaData) {
    const response = await api.post('/citas', citaData);
    return response.data;
  },

  async getAll() {
    const response = await api.get('/citas');
    return response.data;
  }
};

export const resultadosService = {
  async getAll() {
    const response = await api.get('/resultados');
    return response.data;
  }
};

export const facturacionService = {
  async create(formData) {
    const response = await api.post('/facturacion', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async getAll() {
    const response = await api.get('/facturacion');
    return response.data;
  }
};

export const mascotasService = {
  async getAll() {
    const response = await api.get('/mascotas');
    return response.data;
  },

  async create(mascotaData) {
    const response = await api.post('/mascotas', mascotaData);
    return response.data;
  },

  async delete(id) {
    await api.delete(`/mascotas/${id}`);
  }
};